import Configs from "../../config"
import React from "react"
import { FaFileInvoice } from "react-icons/fa"
import { FaCartShopping } from "react-icons/fa6"
import { Button, Modal, ModalBody, ModalHeader, Table } from "reactstrap"

const InvoiceModal = ({ isOpen, toggle, orderData }) => {
  return (
    <Modal isOpen={isOpen} size="xl">
      <ModalHeader toggle={toggle}>
        Invoices for Order : {orderData?.orderId}
      </ModalHeader>
      <ModalBody>
        {orderData?.invoices?.length > 0 ? (
          <div>
            <Table striped>
              <thead className="bg-blue">
                <tr>
                  <th>#</th>
                  <th>Supplier Code</th>
                  <th>Supplier Name</th>
                  <th className="text-center">Invoice</th>
                  <th className="text-center">Delivery Image</th>
                </tr>
              </thead>
              <tbody>
                {orderData?.invoices?.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.supplier?.supplierCode}</td>
                    <td>{item?.supplier?.supplierName}</td>
                    <td className="text-center">
                      <Button
                        className="btn-blue"
                        onClick={() =>
                          window.open(
                            `${Configs.imageUrl}${item?.invoice}`,
                            "_blank"
                          )
                        }
                      >
                        <FaFileInvoice />
                      </Button>
                    </td>
                    <td className="text-center">
                      <Button
                        className="btn-blue"
                        onClick={() =>
                          window.open(
                            `${Configs.imageUrl}${item?.photo}`,
                            "_blank"
                          )
                        }
                      >
                        <FaCartShopping />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : (
          <div>
            <h4>No Invoices Found for This Order</h4>
          </div>
        )}
      </ModalBody>
    </Modal>
  )
}

export default InvoiceModal
